import { Auth } from 'aws-amplify'
import axios from 'axios'
import { stringify } from 'qs'

const baseApi = axios.create({
  paramsSerializer: params => stringify(params, { arrayFormat: 'repeat' }),
})

baseApi.interceptors.request.use(c => {
  return new Promise((resolve, reject) => {
    Auth.currentSession()
      .then(session => {
        const idTokenExpire = session.getIdToken().getExpiration()
        const refreshToken = session.getRefreshToken()
        const currentTimeSeconds = Math.round(+new Date() / 1000)
        if (idTokenExpire < currentTimeSeconds) {
          Auth.currentAuthenticatedUser().then(res => {
            res.refreshSession(refreshToken, (err, data) => {
              if (err) {
                console.error(err)
                Auth.signOut()
              } else {
                c.headers.Authorization = data.getIdToken().getJwtToken()
                resolve(c)
              }
            })
          })
        } else {
          c.headers.Authorization = session.getIdToken().getJwtToken()
          resolve(c)
        }
      })
      .catch(err => {
        console.error(err)
        reject(err)
      })
  })
})
baseApi.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response.status === 401) {
      return new Promise((resolve, reject) => {
        Auth.currentSession()
          .then(session => {
            const refreshToken = session.getRefreshToken()
            Auth.currentAuthenticatedUser().then(res => {
              res.refreshSession(refreshToken, (err, data) => {
                if (err) {
                  console.error(err)
                  Auth.signOut()
                } else {
                  resolve(data)
                }
              })
            })
          })
          .catch(err => {
            console.error(err)
            reject(err)
          })
      })
    }
    console.error(error)
    throw error
  },
)

export default {
  methods: {
    /**
     * mixinGetAPI
     * @param {string} url APIのURL
     * @param {object} params パラメータ
     * @param {object} headers 追加ヘッダー
     */
    async mixinGetAPI(url, params = {}, headers = {}) {
      const res = await baseApi.get(
        url, {
          headers: headers,
          params: params,
        }
      )
      return res.data
    },
    /**
     * mixin Get API, return full response
     * @param {string} url APIのURL
     * @param {object} params パラメータ
     * @param {object} headers 追加ヘッダー
     */
     async mixinGetAPIWithHeader(url, params = {}, headers = {}) {
      const res = await baseApi.get(
        url, {
          headers: headers,
          params: params,
        }
      )
      return res
    },
  },
}
